import {PillTag} from 'components/system/pilltag';
import {PillTagGroup} from 'components/system/pilltag_group';
import {ChevronRightIcon} from 'icons';
import Link from 'next/link';
import {difficultyLevelColors, difficultyLevelNames} from 'types/levels';
import styles from './question_link_list.module.css';

export const QuestionLinkList = ({questions}: Props) => {
  return (
    <div className={styles.container}>
      {questions.map((question) => (
        <QuestionLink key={question.slug} {...question} />
      ))}
    </div>
  );
};

const QuestionLink = ({slug, title, summary, tags, level}: MinimalQuestion) => {
  return (
    <Link prefetch={false} href={`/questions/${slug}`}>
      <a className={styles.link}>
        <div className={styles.content}>
          <strong>{title}</strong>
          {summary && <p>{summary}</p>}
          <PillTagGroup>
            <PillTag color={difficultyLevelColors[level]}>{difficultyLevelNames[level]}</PillTag>
            {(tags || []).map((tag) => (
              <PillTag key={tag.id} color='greyLight'>
                {tag.name}
              </PillTag>
            ))}
          </PillTagGroup>
        </div>
        <ChevronRightIcon />
      </a>
    </Link>
  );
};

type Props = {
  questions: MinimalQuestion[];
};
